import {
  ArcElement,
  CategoryScale,
  Chart,
  Filler,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from "chart.js";
import "chartjs-adapter-moment";
import Annotations from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React from "react";
import { Line } from "react-chartjs-2";

Chart.register(
  Annotations,
  Filler,
  LineController,
  LineElement,
  TimeScale,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  ArcElement,
  ChartDataLabels,
  Tooltip
);
// Data needs to be in format //[{label:"", data: 1, color:""}]
function LineChart({ data, options, id = "linegraph" }) {
  return <Line id={id} height={60} data={data} options={options} />;
}

export default LineChart;
